<script setup lang="ts">
type Props = {
  isLoading: boolean;
  title?: string;
  description?: string;
};

const { isLoading } = defineProps<Props>();
</script>

<template>
  <div :class="$style.boxContainer">
    <h1 :class="$style.title">
      {{ title ?? $t('verification.docs.title') }}
    </h1>

    <p
      :class="$style.description"
      v-html="description ?? $t('verification.docs.desc')"
    />

    <BaseLoading
      class="!bg-bg-primary !absolute"
      :icon-loader="true"
      :show="isLoading"
    />

    <slot />
  </div>
</template>

<style module lang="scss">
.boxContainer {
  @apply p-3 md:p-6 flex flex-col justify-center flex-1 text-texts text-left;

  .title {
    @apply font-bold;
  }

  .description {
    @apply mb-6 max-w-full inline-block text-sm text-texts/80;

    strong {
      @apply text-primary/80;
    }
  }
}
</style>
